<template>
  <div>
    <label class="form-label">
      <small>{{ label }}</small>
    </label>
    <input 
      :type="type"
      :value="value"
      @input="$emit('input', $event.target.value)"
      :placeholder="placeholder"
      class="form-control rounded-8 sin-borde"
    >
  </div>
</template>

<script>
export default {
  name: 'FilterField',
  
  props: {
    label: { type: String, required: true },
    value: { type: String, default: '' },
    type: { type: String, default: 'text' },
    placeholder: { type: String, default: '' }
  },

  emits: ['input']
}
</script>